import React, { useEffect, useState } from "react";
import { isProctoringEnabled } from "../../utils/proctoring";

// Friendly copy for each backend auto-submit reason.
const AUTO_SUBMIT_REASON_TEXT = {
  timer_expired: "Your time ran out, so the test was submitted automatically.",
  user_left: "You left the test, so it was submitted automatically.",
  browser_closed:
    "The test tab was closed or reloaded, so the test was submitted automatically.",
  disconnected:
    "Your connection was lost, so the test was submitted automatically.",
};

const Complete = () => {
  const proctored = isProctoringEnabled();

  const [autoSubmitReason] = useState(() => {
    try {
      return localStorage.getItem("LANGUAGE_TEST_AUTOSUBMIT_REASON");
    } catch (e) {
      return null;
    }
  });

  const reasonText = autoSubmitReason
    ? AUTO_SUBMIT_REASON_TEXT[autoSubmitReason] ||
      "The test was submitted automatically."
    : null;

  useEffect(() => {
    // Give the candidate time to read the auto-submit reason before redirecting.
    const redirectDelay = autoSubmitReason ? 6000 : 500;

    const timer = setTimeout(() => {
      try {
        localStorage.removeItem("LANGUAGE_TEST_AUTOSUBMIT_REASON");
      } catch (e) {
        /* ignore */
      }

      const returnUrl =
        localStorage.getItem("LANGUAGE_TEST_RETURN_URL") ||
        "https://www.gappeo.ai/";

      window.location.href = returnUrl;
    }, redirectDelay);

    return () => clearTimeout(timer);
  }, [autoSubmitReason]);

  return (
    <div className={`language-container${proctored ? "" : " lt-responsive"}`}>
      <div className="language-test-section d-flex">
        <div className="language-left-section" style={{ width: "100%" }}>
          <img src="/images/gappeo-logo.svg" alt="" width={86} height={71} />
          <div className="question-text">
            <h2>🎉 Completed</h2>
            <p>
              Your exam session has been completed. Thanks — you'll be redirected
              shortly.
            </p>
            {reasonText && (
              <p
                style={{
                  marginTop: "12px",
                  padding: "12px 16px",
                  borderRadius: "8px",
                  background: "#fff4e5",
                  color: "#663c00",
                  maxWidth: "420px",
                }}
              >
                {reasonText}
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Complete;
